// Autogenerated file
export const tripSheetTechnicalInspectionTypesEnum = {
    PreTrip: "PreTrip",
    PreShift: "PreShift",
};
export const tripSheetTechnicalInspectionTypes = [
    { label: "Предрейсовый", value: "PreTrip" },
    { label: "Предсменный", value: "PreShift" },
];
